import { BaseButton, OutlinedButton } from 'components/elements';
import { IconPaperClip } from 'components/assets/icons';
import { DownloadOutlined } from "@ant-design/icons";
import {getSaveFileAPI} from 'api/common';
import { message } from 'antd';

//텍스트 
export function Attachment({ name=undefined, label=undefined, url='', icon=undefined, maxLength=20 }) {
  const download = async () => {
    const params = {file_path: `${url?.replace('https://kr.object.ncloudstorage.com','')}` }
    if(url){
      message.info('첨부파일 다운로드 중입니다.')
      await getSaveFileAPI(params)
      .then((response) => {
        const blobData= new Blob([response.data])
        const url2 = window.URL.createObjectURL(blobData); // blob 데이터를 객체 url로 변환
        // 이미지 자동 다운 로직
        const link = document.createElement('a');
        link.href = url2;
        link.setAttribute('download', label)
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link);
      }).catch(err=>console.log(err));
    }else{
      message.warning('다운로드할 첨부파일이 없습니다.')
    }
  }
  const label_class = name 
    ? ( name?.length > maxLength ? 'text-ellipsis' : '' ) 
    : ( label?.length > maxLength ? 'text-ellipsis' : '' )
  const label_style = label_class ? { width: `${maxLength * 5}px` } : {}

  return (
    <BaseButton 
      text={true}
      color={'var(--color-blue01)'}
      padding={'0 0'}
      height={'auto'}
      label={<span className={label_class} style={{...label_style}}>{name || label}</span>}
      icon={icon ? <DownloadOutlined /> : <IconPaperClip />}
      onClick={download}
    />
  )
}

//다운로드버튼
export function AttachmentButton({ name=undefined, label=undefined, url='' }) {
  const download = async () => {
    const params = {file_path: `${url?.replace('https://kr.object.ncloudstorage.com','')}` }
    if(url){
      message.info('첨부파일 다운로드 중입니다.')
      await getSaveFileAPI(params)
      .then((response) => {
        const blobData= new Blob([response.data])
        const url2 = window.URL.createObjectURL(blobData); // blob 데이터를 객체 url로 변환
        // 이미지 자동 다운 로직
        const link = document.createElement('a');
        link.href = url2;
        link.setAttribute('download', label)
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link);
      }).catch(err=>console.log(err));
    }else{
      message.warning('다운로드할 첨부파일이 없습니다.')
    }
  }
  return (
    <OutlinedButton 
      label={name || '다운로드'}
      color={'var(--color-blue01)'} 
      onClick={download}
    /> 
  )
}
